export default __webpack_public_path__ + "static/media/AGE SLA_June_2026.b933a538.pdf";